import { Routes, Route } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { Layout } from './components/Layout'
import { LoadingSpinner } from './components/LoadingSpinner'
import { FeedbackButton } from './components/FeedbackButton'
import { HomePage } from './pages/HomePage'
import { LoginPage } from './pages/LoginPage'
import { RegisterPage } from './pages/RegisterPage'
import { CatalogPage } from './pages/CatalogPage'
import { SolutionDetailPage } from './pages/SolutionDetailPage'
import { ProfilePage } from './pages/ProfilePage'
import { MySubscriptionsPage } from './pages/MySubscriptionsPage'
import { PartnerDashboard } from './pages/PartnerDashboard'
import { PartnerApplication } from './pages/PartnerApplication'
import { AddSolution } from './pages/AddSolution'
import { PartnerAnalytics } from './pages/PartnerAnalytics'
import { AuthCallback } from './components/AuthCallback'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AdminDashboard } from './pages/AdminDashboard'
import { RevenueOptimizationDashboard } from './pages/RevenueOptimizationDashboard'
import CampaignManagement from './pages/CampaignManagement'
import CampaignAnalytics from './pages/CampaignAnalytics'
import { PaymentSuccess } from './pages/PaymentSuccess'
import PaymentCallback from './pages/PaymentCallback'
import { HelpCenter } from './pages/HelpCenter'
import { ContactUs } from './pages/ContactUs'
import { PrivacyPolicy } from './pages/PrivacyPolicy'
import UpgradePage from './pages/UpgradePage'
import CheckoutPage from './pages/CheckoutPage'
import { TermsOfService } from './pages/TermsOfService'
import { AboutUs } from './pages/AboutUs'
import { Blog } from './pages/Blog'

function AppContent() {
  const { user } = useAuth()
  
  return (
    <>
      <LoadingSpinner />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/revenue" element={<RevenueOptimizationDashboard />} />
          <Route path="/admin/campaigns" element={<CampaignManagement />} />
          <Route path="/admin/campaigns/:campaignId/analytics" element={<CampaignAnalytics />} />
          <Route path="/solutions/:id" element={<SolutionDetailPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment-callback" element={<PaymentCallback />} />
          <Route path="/partners" element={
            <ProtectedRoute>
              <PartnerApplication />
            </ProtectedRoute>
          } />
          <Route path="/partner/application" element={
            <ProtectedRoute>
              <PartnerApplication />
            </ProtectedRoute>
          } />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscriptions"
            element={
              <ProtectedRoute>
                <MySubscriptionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partner/dashboard"
            element={
              <ProtectedRoute>
                <PartnerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partner/solutions/add"
            element={
              <ProtectedRoute>
                <AddSolution />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partner/analytics"
            element={
              <ProtectedRoute>
                <PartnerAnalytics />
              </ProtectedRoute>
            }
          />
          <Route path="/upgrade" element={<UpgradePage />} />
          <Route
            path="/checkout/:solutionId"
            element={
              <ProtectedRoute>
                <CheckoutPage />
              </ProtectedRoute>
            }
          />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/help" element={<HelpCenter />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
      </Layout>
      <FeedbackButton 
        source="marketplace" 
        userEmail={user?.email}
        userTier={user?.tier || 'anonymous'}
      />
    </>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App
